import React from 'react';
import MultiPhotoFactory, { MultiPhotoContentProps, MultiPhotoPreviewProps, MultiPhotoProps } from './factory';
import TrackCanvas from './spotify-code/track-canvas';
import classnames from 'classnames';

import styles from './style.less';
export const Content: React.FC<MultiPhotoContentProps> = ({ sourceList, activeIndex }) => (

  <div className={styles.content}>
    {sourceList[activeIndex] &&
      <img src={sourceList[activeIndex].handle} />
    }
  </div>
);

export const PreviewContent: React.FC<MultiPhotoPreviewProps> = ({ sourceList, filmStyle, showSpotify, track, getCodeimgCb,
}) => {
  const renderFilmEnd = () => {
    switch (filmStyle) {
      case 'green':
        return <img src={require(`@/assets/spotify-code-film/end-green.png`)} />
      default:
        return <img src={require(`@/assets/spotify-code-film/eng-right.png`)} />
    }
  }
  return (
    <div className={styles.pfPreview}>

      <div className={styles.previewBox}
        style={{
          animationDuration:  `${1.6 * sourceList.length}s`,
        }}>
        <div className={styles.entryWrapper}>
          <div className={styles.entryBox}>
            <div
              className={styles.entry}
              style={{
                animationDuration: `${1.6 * sourceList.length}s`,
              }}
            >
              <div className={classnames(styles.entryBegin, {
                [styles.entrySypotifyBegin]: showSpotify
              })}>
                {showSpotify ?
                  <div className={styles.trackCanvasWrapper}>
                    <TrackCanvas
                      track={track}
                      getCodeimgCb={getCodeimgCb}
                      filmStyle={filmStyle}
                    />
                  </div>
                  :
                  <img src={require('@/assets/spotify-code-film/film-start.png')} />
                }
              </div>
              <div className={styles.entryContent}>
                <div className={styles.border} />
                <div className={styles.images}>
                  {sourceList.map((item, index) =>
                    <img key={index} src={item.handle} />
                  )}
                </div>
                <div className={styles.border} />
              </div>
            </div>
          </div>
          <div className={styles.entryEnd}>
              <div className={styles.shadowImg}>
                {showSpotify ?
                  <img src={require('@/assets/spotify-code-film/shadow-black.png')} />
                  :
                  <img src={filmStyle=="green" ? require('@/assets/spotify-code-film/shadow-green.png') : require('@/assets/spotify-code-film/shadow-yellow.png')} />
                }
              </div>
            <div className={styles.endContent}>
              <div className={styles.shadow}></div>

              <div className={styles.entryEndImg}>
                {renderFilmEnd()}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const SpotifyCodeFilm: React.FC<Omit<MultiPhotoProps, 'Content' | 'PreviewContent'>> = (props) => {
  return <MultiPhotoFactory {...props} Content={Content} PreviewContent={PreviewContent} />
}

export default SpotifyCodeFilm;
